'use client';

import React, { Suspense } from 'react';
import AdminLoginContent from './AdminLoginContent';
import { Loader2 } from 'lucide-react';

export default function AdminLoginPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-[#0A0D14] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-orange-500 animate-spin" />
      </div>
    }>
      <AdminLoginContent />
    </Suspense>
  );
}
